const prefix = 'instance-users-section';

export const i18n = {
    noUsersMessage: {
        id: `${prefix}.noUsersMessage`,
        defaultMessage: 'There are no users for this instance.',
    },
} as const;
